import React from "react";
import { ShieldCheck, Activity, BadgeEuro, Handshake, CalendarCheck } from "lucide-react";
const trustItems = [{
  id: 1,
  icon: ShieldCheck,
  text: "EU Licensed Clinic"
}, {
  id: 2,
  icon: Activity,
  text: "On-Site Rehabilitation"
}, {
  id: 3,
  icon: BadgeEuro,
  text: "HSE Reimbursement Available"
}, {
  id: 4,
  icon: Handshake,
  text: "Rehabilitation Partnership"
}, {
  id: 5,
  icon: CalendarCheck,
  text: "Surgery in Weeks"
}];
export default function TrustBar() {
  return <section id="trustbar" className="w-full overflow-x-hidden bg-[#eefaf4] py-5 border-y border-[#a9e5c9]">
      {/* Mobiliame: stulpelis, visi elementai lygiuoti vienodai.
          Nuo md: horizontali centruota eile, kaip buvo. */}
      <div className="mx-auto flex w-full max-w-xs flex-col items-stretch gap-4 px-6 md:max-w-full md:flex-row md:flex-wrap md:items-center md:gap-8" style={{
      justifyContent: 'center'
    }}>
        {trustItems.map((item, i) => {
        const Icon = item.icon;
        return <div key={item.id} data-index={i} className="flex items-center gap-3">
              <span className="grid h-10 w-10 shrink-0 basis-10 place-items-center rounded-full bg-[#65d19d] text-[#264256] shadow-sm">
                <Icon className="block h-5 w-5 shrink-0" strokeWidth={2} />
              </span>
              <span className="text-xs font-semibold leading-tight text-[#264256] md:whitespace-nowrap">
                {item.text}
              </span>
            </div>;
      })}
      </div>
    </section>;
}